<script setup lang="ts">
import FAQSection from "@/components/marketing/FAQSection.vue";
import type { CandidatesFAQ } from "@/types/marketing";

interface Props {
  content: CandidatesFAQ;
}

defineProps<Props>();
</script>

<template>
  <FAQSection :title="content.title" :subtitle="content.subtitle" :faqs="content.faqs" />
</template>
